const getSiteVars = () => {
    if (typeof site_vars === 'undefined' || site_vars === null) {
        return {};
    }

    return site_vars;
};

const getSiteVar = (key, fallback = null) => {
    const vars = getSiteVars();
    if (Object.prototype.hasOwnProperty.call(vars, key)) {
        return vars[key];
    }

    return fallback;
};

const getAjaxUrl = () => getSiteVar('ajax_url');
const getPostId = () => getSiteVar('post_id');
const getImgUrl = () => getSiteVar('img_url');
const getPermalink = () => getSiteVar('permalink');
const getServiceSimplyBook = () => getSiteVar('service_simply_book');
const getStatusSimplyBook = () => getSiteVar('status_simply_book');
const getTemplateName = () => getSiteVar('template_name');
const getDomain = () => getSiteVar('domain');
const getDomainUppercase = () => getSiteVar('domain_uppercase');
const getImgUrlGeneral = () => getSiteVar('img_general_url');
const getDomainName = () => getSiteVar('domain_name');
const getFirebaseConfig = () => getSiteVar('firebase_config');
const getJsTranslations = () => getSiteVar('js_translations', {});
const getLocale = () => getSiteVar('locale');
const getLiveUpdateLoaderMarkup = () => getSiteVar('live_update_loader_markup', '');
const getThemeUri = () => getSiteVar('theme_uri');

export {
    getAjaxUrl,
    getDomain,
    getDomainName,
    getDomainUppercase,
    getFirebaseConfig,
    getImgUrl,
    getImgUrlGeneral,
    getJsTranslations,
    getLocale,
    getLiveUpdateLoaderMarkup,
    getPermalink,
    getPostId,
    getServiceSimplyBook,
    getSiteVar,
    getStatusSimplyBook,
    getTemplateName,
    getThemeUri,
};
